import { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const POLICY_VERSION = '2026-02-14';

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(
      'cookieConsent',
      JSON.stringify({
        status: 'accepted',
        version: POLICY_VERSION,
        acceptedAt: new Date().toISOString(),
      })
    );
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10000] bg-white border-t-2 border-purple-200 shadow-2xl animate-slide-up pb-safe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 xl:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-gray-900 mb-1">
                <strong>Vi bruker informasjonskapsler (cookies)</strong>
              </p>
              <p className="text-gray-600 text-sm">
                Vi bruker kun nødvendige cookies for innlogging og sesjonshåndtering. Disse er nødvendige for innlogging og kan ikke deaktiveres. Dersom du ikke ønsker cookies, kan du dessverre ikke bruke tjenesten.
              </p>
            </div>
          </div>
          <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
            <button
              onClick={() => {
                window.location.hash = 'privacy';
              }}
              className="flex-1 sm:flex-none px-4 py-2 border border-purple-300 text-purple-700 rounded-full hover:bg-purple-50 transition-all text-sm"
            >
              Personvern
            </button>
            <button
              onClick={acceptCookies}
              className="flex-1 sm:flex-none px-6 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full hover:shadow-lg transition-all text-sm"
            >
              Forstått
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
